import React from "react";

export const Nda = () => <div>Nda</div>;
